import { Route } from '@angular/router';
import { EquipmentRegistrationPage } from 'app/modules/equipment-registration/pages/equipment-registration/equipment-registration.page';
import { IndexPage } from 'app/modules/equipment-registration/pages/index/index.page';
import { MawopPage } from 'app/modules/equipment-registration/pages/mawop/mawop.page';
import { GeneralComponent } from 'app/modules/equipment-registration/pages/equipment-registration/tabs/general/general.component';
import { CrownValveComponent } from 'app/modules/equipment-registration/pages/equipment-registration/tabs/crown-valve/crown-valve.component';
import { LowerMasterValveComponent } from 'app/modules/equipment-registration/pages/equipment-registration/tabs/lower-master-valve/lower-master-valve.component';
import { KingWingValveComponent } from 'app/modules/equipment-registration/pages/equipment-registration/tabs/king-wing-valve/king-wing-valve.component';
import { WingValveComponent } from 'app/modules/equipment-registration/pages/equipment-registration/tabs/wing-valve/wing-valve.component';
import { SurfaceSafetyValveComponent } from 'app/modules/equipment-registration/pages/equipment-registration/tabs/surface-safety-valve/surface-safety-valve.component';
import { AnnulusAComponent } from 'app/modules/equipment-registration/pages/equipment-registration/tabs/annulus-a/annulus-a.component';
import { AnnulusBComponent } from 'app/modules/equipment-registration/pages/equipment-registration/tabs/annulus-b/annulus-b.component';
import { AnnulusCComponent } from 'app/modules/equipment-registration/pages/equipment-registration/tabs/annulus-c/annulus-c.component';
import { AnnulusDComponent } from 'app/modules/equipment-registration/pages/equipment-registration/tabs/annulus-d/annulus-d.component';
import { WrsvScssvComponent } from 'app/modules/equipment-registration/pages/equipment-registration/tabs/wrsv-scssv/wrsv-scssv.component';
import { XmasTreeComponent } from 'app/modules/equipment-registration/pages/equipment-registration/tabs/xmas-tree/xmas-tree.component';
import { TrsssvComponent } from 'app/modules/equipment-registration/component/trsssv/trsssv.component';
import { WrsvComponent } from 'app/modules/equipment-registration/component/wrsv/wrsv.component';

export const eRegDashboardRoutes: Route[] = [
    {
        path: 'eReg',
        children: [],
    },
];

export const eRegDataManagementRoutes: Route[] = [
    {
        path: 'eReg',
        component: IndexPage,
        children: [
            {
                path: '',
                pathMatch : 'full',
                redirectTo: 'equipment-registration',
            },
            {
                path: 'equipment-registration',
                component: EquipmentRegistrationPage,
                children: [
                    {
                        path: '',
                        pathMatch : 'full',
                        redirectTo: 'general',
                    },
                    {
                        path: 'xmastree',
                        component: XmasTreeComponent,
                    },
                    {
                        path: 'general',
                        component: GeneralComponent,
                    },
                    {
                        path: 'cv',
                        component: CrownValveComponent,
                    },
                    {
                        path: 'lmv',
                        component: LowerMasterValveComponent,
                    },
                    {
                        path: 'kwv',
                        component: KingWingValveComponent,
                    },
                    {
                        path: 'wgv',
                        component: WingValveComponent,
                    },
                    {
                        path: 'ssv',
                        component: SurfaceSafetyValveComponent,
                    },
                    {
                        path: 'annulus-valve-a',
                        component: AnnulusAComponent,
                    },
                    {
                        path: 'annulus-valve-b',
                        component: AnnulusBComponent,
                    },
                    {
                        path: 'annulus-valve-c',
                        component: AnnulusCComponent,
                    },
                    {
                        path: 'annulus-valve-d',
                        component: AnnulusDComponent,
                    },
                    {
                        path: 'trscssv-wrsv',
                        component: WrsvScssvComponent,
                        children: [
                            {
                                path: 'trscssv',
                                component: TrsssvComponent,
                            },
                            {
                                path: 'wrsv',
                                component: WrsvComponent,
                            },
                        ]
                    },
                ]
            },
            {
                path: 'mawop',
                component: MawopPage,
            },
        ],
    },
];

export const eRegConfigurationRoutes: Route[] = [
    {
        path: 'eReg',
        children: [],
    },
];
